module.exports = __webpack_public_path__ + "static/media/add quiz info.14aea19b.svg";